import React, { useEffect, useMemo } from 'react';
import { CalculationStatisticRouteResponse } from '@ydistri/api-sdk';
import PrefilledTableRoute from '../../Statistics/modal/Routes/PrefilledTableRoute';
import { useCurrency } from '../../../../hooks/useCurrency';
import { useApplicationData } from '../../../../hooks/useApplicationData';
import { buildRouteStats } from './routeStats';
import { ChangelogSectionProps, parseChangelogData } from '../editRedistributionLib';

const ChangelogRoutes: React.FC<ChangelogSectionProps> = ({ stringifiedData, onStatsComputed }) => {
  const currency = useCurrency();
  const { departments: hasDepartments } = useApplicationData();

  const data = useMemo(
    () => parseChangelogData<CalculationStatisticRouteResponse>(stringifiedData),
    [stringifiedData],
  );

  const useDepartments = data.some(i => i.department);

  useEffect(() => {
    onStatsComputed(buildRouteStats(data, currency));
  }, [data, currency, onStatsComputed]);

  if (data.length === 0) return null;

  return <PrefilledTableRoute data={data} displayDepartment={hasDepartments && useDepartments} />;
};

export default ChangelogRoutes;
